import { StandService } from 'app/stand/stand.service';
import { ICompany } from '@collections/companies/interfaces/company.interface';
import { Component, Inject, LOCALE_ID, OnInit, ViewChild, ViewEncapsulation, ElementRef, ChangeDetectionStrategy, signal, computed } from '@angular/core';
import { QueryRef } from 'apollo-angular';
import { IconsLoader } from 'app/shared/services/icons/icons-loader.service';
import { RandomProductsPageGQL, RandomProductsPageResponse, DEFAULT_RANDOM_SEED } from '@shared/services/products/graphql/random-products-page.gql.service';
import { Platform } from '@angular/cdk/platform';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { UsersService } from 'app/shared/services/users/users.service';
import { RoutesService } from 'app/shared/services/routes/route.service';
import { WatchQueryFetchPolicy } from '@apollo/client/core';
import { GetCompanyUrlPipe } from '../shared/pipes/get-company-url.pipe';
import { ProductBlockComponent } from '../products/views/product-block/product-block.component';
import { InfoBarComponent } from '../stand/components/info-bar/info-bar.component';
import { RenderIfDirective } from '../shared/directives/render-if.directive';
import { NewsBlockComponent } from 'app/news/views/news-block/news-block.component';
import { NewsGQL, NewsResponse } from 'app/shared/services/news/news.gql.service';
import { NewsStatusEnum, NewsTypeEnum } from '@collections/news/enums/news.enums';
import { TransferState, makeStateKey } from '@angular/core';
import { PagedVirtualScrollerModule } from 'app/shared/components/paged-virtual-scroller/paged-virtual-scroller.module';
import { Router, RouterOutlet } from '@angular/router';
import { DataSharingService } from 'app/stand/components/data-sharing.service';

export const RANDOM_SEED = makeStateKey<any>('expo.random_seed');
export const HAS_PRODUCTS = makeStateKey<any>('expo.has_products');
export const HAS_NEWS= makeStateKey<any>('expo.has_news');

@UntilDestroy()
@Component({
    selector: 'stand-free',
    templateUrl: './stand-free.component.html',
    styleUrls: ['./stand-free.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        RouterOutlet,
        RenderIfDirective,
        InfoBarComponent,
        PagedVirtualScrollerModule,
        ProductBlockComponent,
        NewsBlockComponent,
        GetCompanyUrlPipe,
    ],
    providers: [
      RandomProductsPageGQL,
      NewsGQL
    ]
})
export class StandFreeComponent implements OnInit {
  scaleUpOnRender = true;
  productsQuery: QueryRef<RandomProductsPageResponse>;
  newsQuery:  QueryRef<NewsResponse>;
  showOverlay: boolean;
  company = signal<ICompany>(null);

  @ViewChild('description', { static: false }) description: ElementRef;


  currentHallCssClass = computed(() => {
    const cat = this.standService.currentCategory();
    return cat.parent?.cssClass ?? cat.cssClass;
  });

  isCanonicalPage = computed(() => {
    const cat = this.standService.currentCategory();
    return cat.path === this.company().primaryPath;
  });

  hasProducts = signal(false);
  hasNews = signal(false);
  private randomSeed: number = DEFAULT_RANDOM_SEED;

  constructor(
    private iconsLoader: IconsLoader,
    private randomProductsPageGQL: RandomProductsPageGQL,
    private newsGQL: NewsGQL,
    @Inject(LOCALE_ID) private locale: string,
    public standService: StandService,
    private readonly usersService: UsersService,
    private router: Router,
    private routesService: RoutesService,
    private platform: Platform,
    private readonly transferState: TransferState,
    private dataSharingService: DataSharingService,
  ) {
    this.iconsLoader.load('stand');
    this.iconsLoader.load('halls');

    this.dataSharingService.overlayVisible$.subscribe(isVisible =>{
      this.showOverlay = isVisible;
    })
  }


  ngOnInit(): void {
    this.standService.getCurrentCompany()
    .pipe(untilDestroyed(this))
    .subscribe(company => {
      let fetchPolicy: WatchQueryFetchPolicy = 'cache-first';
      if (!company) {
        throw new Error('Company not found!')
      }

      this.company.set(company);
      if (this.platform.isBrowser) {
        this.randomSeed = this.transferState.get<number>(RANDOM_SEED, this.randomProductsPageGQL.getRandomSeed());
        this.hasProducts.set(this.transferState.get<boolean>(HAS_PRODUCTS, false));
        this.hasNews.set(this.transferState.get<boolean>(HAS_NEWS, false));
        this.scaleUpOnRender = !this.transferState.hasKey(RANDOM_SEED);
      } else {
        this.randomSeed = this.randomProductsPageGQL.getRandomSeed();
        this.transferState.set<number>(RANDOM_SEED, this.randomSeed);
      }

      this.newsQuery = this.newsGQL.watch({
        newsType: NewsTypeEnum.all,
        newsStatus: NewsStatusEnum.portalLevelValidated,
        lang: this.locale,
        category: this.standService.currentCategory().path,
        first: 6
      });

      this.productsQuery = this.randomProductsPageGQL.watch({
        lang: this.locale,
        category: this.standService.currentCategory().path,
        seed: this.randomSeed,
        first: 16
        }, {
          fetchPolicy: fetchPolicy
        });

      // setTimeout(() => {

  
      //   this.newsQuery.valueChanges
      //   .pipe(
      //     take(1)
      //   ).subscribe(({data}) => {
      //     const hasNews = data.news.totalCount > 0;
      //     this.hasNews.set(hasNews);
      //     if(!this.platform.isBrowser) {
      //       this.transferState.set<boolean>(HAS_NEWS, hasNews);
      //     }
      //   });
  

  
      //     this.productsQuery.valueChanges
      //     .pipe(
      //       take(1)
      //     ).subscribe(({data}) => {
      //       const hasProducts = data.randomProductsPage.totalCount > 0;
      //       this.hasProducts.set(hasProducts);
      //       if(!this.platform.isBrowser) {
      //         this.transferState.set<boolean>(HAS_PRODUCTS, hasProducts);
      //       }
      //     });
      // }, 100);
 

        this.standService.appendCompanyMetaTags(this.standService.canonicalDefaultUrl);

    });
  // });
    
  }

  updateFreeCompanyData(): void {
    this.usersService.checkPermission(() => {
      this.router.navigate([this.routesService.getCompanyEditUrl(this.company())]);
    });
  }

}
